import { Route, Routes } from "react-router-dom";

import { Routes as AdminRoutes } from "ui/modules/navigation";

import { TranslationSearchPage } from "../pages/TranslationSearchPage";

import { TranslationRouterCmp } from "./types";

const TranslationRouter: TranslationRouterCmp = () => (
  <Routes>
    <Route path={TranslationSearchPage.route} element={<TranslationSearchPage />} />
  </Routes>
);

TranslationRouter.route = AdminRoutes.ModuleRouter;

export default TranslationRouter;
